'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCertificate = function FaCertificate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.7 20l3.1 3q0.7 0.6 0.4 1.6-0.2 0.9-1.1 1.1l-4.2 1.1 1.2 4.1q0.2 1-0.5 1.6-0.6 0.7-1.5 0.4l-4.2-1.2-1 4.2q-0.3 0.9-1.2 1.2-0.3 0-0.4 0-0.7 0-1.1-0.4l-3.1-3.1-3 3.1q-0.6 0.6-1.5 0.4-0.9-0.2-1.2-1.2l-1-4.2-4.2 1.2q-0.9 0.3-1.6-0.4-0.7-0.6-0.4-1.6l1.2-4.1-4.2-1.1q-0.9-0.2-1.2-1.1-0.2-1 0.5-1.6l3.1-3-3.1-3q-0.7-0.6-0.5-1.6 0.3-0.9 1.2-1.1l4.2-1.1-1.2-4.1q-0.3-1 0.4-1.6 0.7-0.7 1.6-0.4l4.2 1.2 1-4.2q0.3-1 1.2-1.2 0.9-0.2 1.5 0.4l3 3.1 3.1-3.1q0.6-0.6 1.5-0.4 0.9 0.2 1.2 1.2l1 4.2 4.2-1.2q0.9-0.3 1.5 0.4 0.7 0.6 0.5 1.6l-1.2 4.1 4.2 1.1q0.9 0.2 1.1 1.1 0.3 1-0.4 1.6z' })
        )
    );
};

exports.default = FaCertificate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/certificate.js
// module id = 688
// module chunks = 35783957827783